import { selectWarehouseStatesIsLoading } from 'containers/Warehouses/warehousesSlice'
import rightDoorClassic from 'assets/warehouse/classic/rightDoor.png'
import leftDoorClassic from 'assets/warehouse/classic/leftDoor.png'
import rightDoorHT from 'assets/warehouse/htbox/rightDoor.png'
import leftDoorHT from 'assets/warehouse/htbox/leftDoor.png'
import rightDoorMM from 'assets/warehouse/mm/rightDoor.png'
import leftDoorMM from 'assets/warehouse/mm/leftDoor.png'
import useTranslation from 'hooks/useTranslation'
import shadow from 'assets/warehouse/shadow.png'
import { useReduxSelector } from 'store'
import StorageUnit from './StorageUnit'
import Alert from './Alert'
import React from 'react'
import './style.scss'

interface WarehouseProps {
  name?: string
  warning?: boolean
  showShadow?: boolean
  image?: string
  warehouseAnimation?: warehouse.WarehouseAnimation
  rentableType?: warehouse.RentableType
  lock?: warehouse.WarehouseLockState
  door?: warehouse.WarehouseDoorState
  alert?: warehouse.WarehouseAlert
}

const type = process.env.REACT_APP_TYPE
const Warehouse: React.FC<WarehouseProps> = ({ lock = 'locked', door = 'closed', warehouseAnimation, image, rentableType, name, warning, alert, showShadow = false }) => {
  const isLoading = useReduxSelector(selectWarehouseStatesIsLoading)
  const { t } = useTranslation('basic')

  if (rentableType === 'parking') {
    return (
      <div className={`warehouse__animation --parking ${warning ? ' --warning' : showShadow ? ' --shadow' : ''}`}>
        <div className={`animation__interior${alert ? ' --withOverlay' : ''}`}>
          {alert
            ? <Alert
              {...alert}
            />
            : null}
        </div>
      </div>
    )
  }


  if (image) {
    return (
      <div className={`warehouse__animation --custom ${warning ? ' --warning' : showShadow ? ' --shadow' : ''}`}>
        <div
          className={`animation__interior${isLoading || alert ? ' --withOverlay' : ''}`}
          style={{ backgroundImage: `url(${image})` }}>
          {isLoading
            ? <div className='warehouse__popup'>
              <div className='popup__title'>
                <div>{t('resyncStatus')}</div>
              </div>
            </div>
            : alert
              ? <Alert
                {...alert}
              />
              : null}
        </div>
      </div>
    )
  }

  // ldz01 – zdjęcie korytarza z boksami + drzwi w CSS 3D (numer boksu na drzwiach)
  if (type === 'ldz01') {
    return (
      <div className={`warehouse__animation --storageUnit ${warning ? ' --warning' : showShadow ? ' --shadow' : ''}`}>
        <StorageUnit
          door={door}
          lock={lock}
          overlay={isLoading
            ? <div className='warehouse__popup'>
              <div className='popup__title'>
                <div>{t('resyncStatus')}</div>
              </div>
            </div>
            : alert
              ? <Alert {...alert} />
              : null}>
          {name && <div className='storageUnit__number'>
            <span>{t('numberShort')}</span>
            <div className='--secFont'>{name}</div>
          </div>}
        </StorageUnit>
      </div>
    )
  }

  const data = getData(warehouseAnimation)

  return (
    <div className={`warehouse__animation --${lock} --${door} --${data.className} ${warning ? ' --warning' : showShadow ? ' --shadow' : ''}`}>
      <div className='animation__interior'>
        {data.left && data.right && <>
          <img
            className='animation__door --left'
            src={data.left}
            decoding='sync'
            alt='door'
          />
          <img
            className='animation__door --right'
            src={data.right}
            decoding='sync'
            alt='door'
          />
          <img
            className='animation__shadow'
            src={shadow}
            alt='shadow'
          />
        </>}
        {process.env.REACT_APP_TYPE === 'mm' && name && <div className='warehouse__animation__number'>
          <span>{t('numberShort')}</span>
          <div className='--secFont'>{name}</div>
        </div>}
        {isLoading
          ? <div className='warehouse__popup'>
            <div className='popup__title'>
              <div>{t('resyncStatus')}</div>
            </div>
          </div>
          : alert
            ? <Alert
              {...alert}
            />
            : null}
      </div>
    </div>
  )
}

const getData = (animation?: warehouse.WarehouseAnimation) => {
  switch (true) {
    case (animation === 'htbox' || type === 'rze01' || type === 'krk01' || type === 'demo'):
      return {
        className: 'htbox',
        left: leftDoorHT,
        right: rightDoorHT
      }

    case (animation?.startsWith('mm') || type === 'mm'):
      return {
        className: 'mm',
        left: leftDoorMM,
        right: rightDoorMM
      }

    default:
      return {
        className: 'classic',
        left: leftDoorClassic,
        right: rightDoorClassic
      }
  }
}

export default Warehouse